import { ImageManagementSection } from '@/components/shared/ImageManagementSection';
import { usePaymentImages } from '../hooks/usePaymentImages';
import { useUploadPaymentImages } from '../hooks/useUploadPaymentImages';

export interface PaymentImagesSectionProps {
  jobId: number;
  paymentId: number;
  canDelete?: boolean;
}

/**
 * Payment-specific image management section
 * Thin wrapper around ImageManagementSection with payment-specific hooks
 * Used for check images, receipts, and other payment documents
 */
export function PaymentImagesSection({
  jobId,
  paymentId,
  canDelete = false,
}: PaymentImagesSectionProps) {
  const { images, isLoading, error: fetchError, refetch, deleteImage } = usePaymentImages(jobId, paymentId);
  const { uploadImages, isUploading, error: uploadError } = useUploadPaymentImages(jobId, paymentId, refetch);

  return (
    <ImageManagementSection
      images={images}
      isLoading={isLoading}
      fetchError={fetchError}
      uploadError={uploadError}
      isUploading={isUploading}
      onUpload={uploadImages}
      onDelete={deleteImage}
      canDelete={canDelete}
      uploadLabel="Upload Documents"
      galleryLabel="Uploaded Documents"
    />
  );
}
